/** Homepage-aligned marketing design tokens (see HomePage.tsx). */
export const marketingBrand = {
  black: '#0A0B0B',
  white: '#F7F8F6',
  tapeTurquoise: '#0D3135',
  utilityBlue: '#145F6C',
  drillbitSkies: '#4A7D83',
  sandrift: '#AB9381',
  plaster: '#CECAC3',
} as const

export const PAPER = '#F0EDE8'
export const DARK = '#0B272C'

export const BOOKING_CALENDAR_URL =
  'https://api.leadconnectorhq.com/widget/booking/vGBU75grNpdx4TI2SvX2'

export const marketingEase = [0.16, 1, 0.3, 1] as const

/** Same keys as legacy `colors` objects on service pages — maps to homepage palette. */
export const marketingColors = {
  teal: marketingBrand.utilityBlue,
  tealDark: marketingBrand.tapeTurquoise,
  copper: marketingBrand.sandrift,
  cream: PAPER,
  nearBlack: marketingBrand.black,
  drillbitSkies: marketingBrand.drillbitSkies,
  plaster: marketingBrand.plaster,
}
